export enum Terms {
  REAL = 0,
  NOMINAL = 1,
}
